import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: () => ({
    country_id: null,
    order_id: null,
    currency_code: null,
    installment_default: 12,
    recaptcha_attempts: null,
    settings: null,
    store_name: null,
    orderBumpRedirected: false,
    visit: {},
    enable_address: null,
    freights: [],
    hash: null,
    shop_url: null,
    shop_cancel_url: null,
    store_id: 0,
    discount: 0,
    freight: 0,
    total: 0,
    tributes: [],
    subtotal: 0,
    coupon: {},
    items: JSON.parse(localStorage.getItem('items')),
    order: {},
    installments: [],
    countries: [],
    freight_id: null,
    upsell_hash: null,
    selected_installment: null,
    is_international: null,
    enable_international: null,
    store_allow_cnpj: null,
  }),
  actions,
  mutations,
  getters,
}
